var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.SpinLuckRuleConfig, {
        attrs: { "rule-flags": _vm.ruleFlags, "rule-values": _vm.ruleValues },
      }),
      _c(
        "el-form-item",
        {
          staticClass: "form-item-vips",
          attrs: { label: "活动对象", prop: "vips", "label-width": "120px" },
        },
        [
          _c(
            "div",
            { staticClass: "vips-wrap", staticStyle: { width: "80%" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: {
                    indeterminate: _setup.vipIndeterminate,
                    value: _setup.isAllVipChecked,
                  },
                  on: { change: _setup.onVipCheckAllChange },
                },
                [_vm._v(" 全选 ")]
              ),
              _c(
                "el-checkbox-group",
                {
                  staticClass: "vips-group",
                  on: { change: _setup.syncVipCheckAllState },
                  model: {
                    value: _vm.localForm.vips,
                    callback: function ($$v) {
                      _vm.$set(_vm.localForm, "vips", $$v)
                    },
                    expression: "localForm.vips",
                  },
                },
                _vm._l(_vm.vipOptions, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.value, attrs: { label: item.value } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(_setup.SpinLuckTiersConfig, { attrs: { tiers: _vm.localForm.tiers } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }